import axios from 'axios';
import config from '../config';

const axiosInstance = axios.create({
  baseURL: config.apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const csrfToken = localStorage.getItem("csrfToken");
    const sessionId = localStorage.getItem("sessionId");

    if (csrfToken) {
      config.headers["X-CSRFToken"] = csrfToken;
    }
    if (sessionId) {
      config.headers["Authorization"] = `Session ${sessionId}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      const errorMessage = error.response?.data?.error || "";
      if (errorMessage.includes("Se ha superado el número de intentos fallidos")) {
        return Promise.reject(error);
      }
      localStorage.removeItem("csrfToken");
      localStorage.removeItem("sessionId");

      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
